// extracted by css-extract-rspack-plugin
export default {"confirmRow":"confirmRow-jhDrrP","box":"box-msAktD"};